<template>
  <v-card
    class="empty-state text-center"
    :class="{ 'card-cambio': !grayBackground, 'empty-state--gray-bg': grayBackground }"
    :style="cardStyle"
    outlined
  >
    <div
      class="empty-state__content"
      :class="{ 'empty-state__content--gray': grayBackground }"
      :style="contentStyle"
    >
      <div class="empty-state__icon">
        <component
          :is="icon"
          :size="iconSize"
          :color="iconColor"
        />
      </div>
      <span
        class="empty-state__title"
        :style="{ color: iconColor }"
      >
        {{ title }}
      </span>
      <span
        v-if="subtitle"
        class="empty-state__subtitle"
        :style="{ color: iconColor }"
      >
        {{ subtitle }}
      </span>
      <v-btn
        v-if="nameOfButton && callbackButton"
        :data-test="dataTestButton"
        text
        class="btn-primary mt-4"
        outlined
        @click="callbackButton"
      >
        {{ nameOfButton }}
      </v-btn>
    </div>
  </v-card>
</template>

<script>
import { PhCurrencyCircleDollar } from 'phosphor-vue';

export default {
  name: 'EmptyState',
  components: {
    PhCurrencyCircleDollar
  },
  props: {
    title: {
      type: String,
      default: 'Nenhum registro encontrado'
    },
    subtitle: {
      type: String,
      default: ''
    },
    nameOfButton: {
      type: String,
      default: ''
    },
    callbackButton: {
      type: Function,
      default: null
    },
    minHeight: {
      type: String,
      default: '200px'
    },
    icon: {
      type: [String, Object, Function],
      default: 'PhCurrencyCircleDollar'
    },
    iconSize: {
      type: Number,
      default: 48
    },
    grayBackground: {
      type: Boolean,
      default: false
    },
    dataTestButton: {
      type: String,
      default: ''
    }
  },
  computed: {
    iconColor() {
      return this.$vuetify.theme.currentTheme.table?.emptyState || '#757575';
    },
    grayBgColor() {
      const isDark = this.$vuetify?.theme?.dark;

      return isDark ? 'rgba(255, 255, 255, 0.04)' : 'rgba(0, 0, 0, 0.02)';
    },
    cardStyle() {
      const base = {};

      if (this.grayBackground) {
        base.backgroundColor = this.grayBgColor;
      }

      return base;
    },
    contentStyle() {
      const base = { minHeight: this.minHeight };

      if (this.grayBackground) {
        base.backgroundColor = this.grayBgColor;
      }

      return base;
    }
  }
};
</script>

<style lang="scss" scoped>
.empty-state__content {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 32px 24px;
}

.empty-state__icon {
  display: flex;
  justify-content: center;
  align-items: center;
}

.empty-state__title {
  display: block;
  font-size: 1.15rem;
  font-weight: 500;
  padding: 16px 0 8px;
}

.empty-state__subtitle {
  display: block;
  font-size: 0.95rem;
  text-align: center;
  opacity: 0.9;
}
</style>

<style lang="scss">
/* Mesmo cinza do fundo do nome do beneficiário (BankAccountCard/InternationalBankAccountCard __body) */
.v-card.empty-state--gray-bg,
.v-card.empty-state--gray-bg .v-card__text,
.empty-state__content--gray {
  background-color: rgba(0, 0, 0, 0.02) !important;
}

.theme--dark .v-card.empty-state--gray-bg,
.theme--dark .v-card.empty-state--gray-bg .v-card__text,
.theme--dark .empty-state__content--gray {
  background-color: rgba(255, 255, 255, 0.04) !important;
}
</style>
